import React, { createElement } from 'react';
import PropTypes from 'prop-types';

import acquisitionTypes from '../../support/acquisitionTypes.ts';
import BatchDownloadForm from './Forms/BatchDownloadForm/BatchDownloadForm';
import CartCheckoutAdpForm from './Forms/CartCheckoutAdpForm/CartCheckoutAdpForm';
import DownloadForm from './Forms/DownloadForm/DownloadForm';
import LicenseForm from './Forms/LicenseForm/LicenseForm';
import LimitedUseProductsForm from './Forms/LimitedUseProductsForm/LimitedUseProductsForm';
import UltraPackUpsellForm from './Forms/UltraPackUpsellForm/UltraPackUpsellForm';
import PaPreviewForm from './Forms/PaPreviewForm/PaPreviewForm';
import RestrictedForm from './Forms/RestrictedForm/RestrictedForm';
import ModifiedLicenseForm from './Forms/ModifiedLicenseForm/ModifiedLicenseForm';
import ModifiedDownloadForm from './Forms/ModifiedDownloadForm/ModifiedDownloadForm';
import ModifiedDownloadCompletedForm from './Forms/ModifiedDownloadCompletedForm/ModifiedDownloadCompletedForm';
import ModifiedLicenseRedownloadForm from './Forms/ModifiedLicenseRedownloadForm/ModifiedLicenseRedownloadForm';
import SubscriptionLicenseForm from './Forms/SubscriptionLicenseForm/SubscriptionLicenseForm.tsx';
import SubscriptionDownloadForm from './Forms/SubscriptionDownloadForm/SubscriptionDownloadForm.tsx';
import AlaCarteLicenseForm from './Forms/AlaCarteLicenseForm/AlaCarteLicenseForm.tsx';

const MultiForm = ({ acquisitionFormType = '', acquisitionType = null }) => {
  const formMap = {
    [acquisitionTypes.BATCH_DOWNLOAD]: BatchDownloadForm,
    [acquisitionTypes.DOWNLOAD]: DownloadForm,
    [acquisitionTypes.LICENSE]: LicenseForm,
    [acquisitionTypes.LIMITED_USE_PRODUCTS]: LimitedUseProductsForm,
    [acquisitionTypes.ULTRA_PACK_UPSELL]: UltraPackUpsellForm,
    [acquisitionTypes.PREVIEW]: PaPreviewForm,
    [acquisitionTypes.RESTRICTED]: RestrictedForm,
    [acquisitionTypes.CART_ADP_CONFIRMATION]: CartCheckoutAdpForm,
    [acquisitionTypes.MODIFIED_LICENSE]: ModifiedLicenseForm,
    [acquisitionTypes.MODIFIED_DOWNLOAD]: ModifiedDownloadForm,
    [acquisitionTypes.MODIFIED_DOWNLOAD_IN_PROGRESS]: ModifiedDownloadForm,
    [acquisitionTypes.MODIFIED_DOWNLOAD_COMPLETED]:
      ModifiedDownloadCompletedForm,
    [acquisitionTypes.MODIFIED_LICENSE_REDOWNLOAD]:
      ModifiedLicenseRedownloadForm,
    [acquisitionTypes.MODIFIED_CART_CONFIRMATION]: ModifiedLicenseForm,
    [acquisitionTypes.MODIFIED_LIMITED_USE_PRODUCTS]: LimitedUseProductsForm,
    [acquisitionTypes.SUBSCRIPTION_LICENSE]: SubscriptionLicenseForm,
    [acquisitionTypes.SUBSCRIPTION_DOWNLOAD]: SubscriptionDownloadForm,
    [acquisitionTypes.ALACARTE_LICENSE]: AlaCarteLicenseForm,
  };

  if (!acquisitionFormType) {
    // todo: show a component loader (skeleton here)
    return null;
  }
  return (
    <div data-testid="acquisition-multi-form">
      {createElement(formMap[acquisitionFormType], { key: acquisitionType })}
    </div>
  );
};

MultiForm.propTypes = {
  acquisitionFormType: PropTypes.string,
  acquisitionType: PropTypes.string,
};

export default React.memo(MultiForm);
